/**
 * Tire Diagram — Realistic tire image with SVG text overlay and animated pointer.
 * Uses a photorealistic tire cross-section PNG as background.
 */

class TireDiagram {
  constructor(containerId) {
    this.container = document.getElementById(containerId);
    this.values = { width: '___', height: '__', inch: '__', load: '__', speed: '_' };
    this.activeStep = 0;
    this.render();
  }

  render() {
    var tireCrosssectionUrl = (window.acsHeroBannerAssets && window.acsHeroBannerAssets.tireCrosssection) || '';

    this.container.innerHTML = `
      <div class="tire-diagram-wrapper">
        <div class="tire-image-container">
          <img src="${tireCrosssectionUrl}" alt="Tire cross-section" class="tire-photo" />
          <svg viewBox="0 150 400 400" class="tire-overlay-svg" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <!-- Arc path positioned on the tire sidewall -->
              <path id="tireTextArc" d="M 75 330 A 140 140 0 0 1 325 330" fill="none" />
            </defs>

            <!-- Tire size text curved along sidewall -->
            <text class="tire-curved-text" id="tireCurvedText">
              <textPath href="#tireTextArc" startOffset="50%" text-anchor="middle">
                <tspan id="svgWidth" class="tire-text-val">${this.values.width}</tspan>/<tspan id="svgHeight" class="tire-text-val">${this.values.height}</tspan> R <tspan id="svgInch" class="tire-text-val">${this.values.inch}</tspan> <tspan id="svgLoad" class="tire-text-val">${this.values.load}</tspan><tspan id="svgSpeed" class="tire-text-val">${this.values.speed}</tspan>
              </textPath>
            </text>

            <!-- Pointer line from bottom center to active text segment -->
            <g id="diagramPointer" class="tire-pointer">
              <line id="pointerLine" x1="200" y1="420" x2="200" y2="330" 
                    stroke="var(--primary)" stroke-width="3" stroke-linecap="round" />
              <circle id="pointerDot" cx="200" cy="330" r="5" fill="var(--primary)" />
            </g>

            <!-- Active step label -->
            <text id="diagramStepLabel" x="200" y="460" text-anchor="middle" 
                  class="tire-step-label" fill="var(--primary)"></text>
          </svg>
        </div>
      </div>
    `;
    this._cacheElements();
  }

  _cacheElements() {
    this.els = {
      width: document.getElementById('svgWidth'),
      height: document.getElementById('svgHeight'),
      inch: document.getElementById('svgInch'),
      load: document.getElementById('svgLoad'),
      speed: document.getElementById('svgSpeed'),
      pointerLine: document.getElementById('pointerLine'),
      pointerDot: document.getElementById('pointerDot'),
      label: document.getElementById('diagramStepLabel'),
    };
  }

  updateValue(stepKey, value) {
    this.values[stepKey] = value;
    if (this.els[stepKey]) {
      this.els[stepKey].textContent = value;
    }
  }

  setActiveStep(stepIndex) {
    this.activeStep = stepIndex;

    // Pointer rotates from the bottom center (200, 365)
    // pointing upward toward each text position on the arc
    const pointerConfigs = [
      { angle: -40, label: 'Briete' },
      { angle: -18, label: 'Höhe' },
      { angle: 18, label: 'Zoll' },
      { angle: 36, label: 'Last' },
      { angle: 46, label: 'Speed' },
    ];

    const config = pointerConfigs[stepIndex] || pointerConfigs[0];
    const rad = (config.angle * Math.PI) / 180;
    const cx = 200;
    const cy = 375;
    const lineLen = 80;

    const endX = cx + lineLen * Math.sin(rad);
    const endY = cy - lineLen * Math.cos(rad);

    if (this.els.pointerLine) {
      this.els.pointerLine.setAttribute('x2', endX.toFixed(1));
      this.els.pointerLine.setAttribute('y2', endY.toFixed(1));
    }
    if (this.els.pointerDot) {
      this.els.pointerDot.setAttribute('cx', endX.toFixed(1));
      this.els.pointerDot.setAttribute('cy', (endY - 2).toFixed(1));
    }
    if (this.els.label) {
      this.els.label.textContent = config.label;
    }

    // Highlight active text segment
    const keys = ['width', 'height', 'inch', 'load', 'speed'];
    keys.forEach((key, i) => {
      if (this.els[key]) {
        this.els[key].classList.toggle('active-segment', i === stepIndex);
      }
    });
  }

  reset() {
    this.values = { width: '___', height: '__', inch: '__', load: '__', speed: '_' };
    Object.keys(this.values).forEach(key => {
      if (this.els[key]) {
        this.els[key].textContent = this.values[key];
      }
    });
    this.setActiveStep(0);
  }
}
